import sendQuery from './send-query';

export default async (product_handle = '') => {
  try {
    if (product_handle.length === '') return [];
    const total_media = 200;

    const query = `
      query {
        productByHandle(handle: "${product_handle}") {
          media(first: ${total_media}) {
            edges {
              node {
                mediaContentType
                ... on Video {
                  sources {
                    url
                    format
                  }
                }
                ... on MediaImage {
                  id
                  image {
                    url
                  }
                }
              }
            }
          }
        }
      }
    `;

    // console.log('query', query);

    const response = await sendQuery(query);

    if (!response.ok) {
      // throw new Error(`HTTP error ${response.status}`);
      console.log(`HTTP error ${response.status}`);
      return [];
    }

    const response_json = await response.json();
    if (response_json.length === total_media) {
      console.warn('[ASTR] We reached the medias limit for product', product_handle);
    }
    // console.log('response_json', response_json);

    if (typeof response_json.errors !== 'undefined') {
      console.log('[Storefront API] Error in response:', response_json.errors);
      return [];
    }

    if (typeof response_json.data === 'undefined') {
      console.log('[Storefront API] No data', response_json);
      return [];
    }

    return response_json.data?.productByHandle?.media?.edges ?? [];
  } catch (error) {
    console.log('[Storefront API]', error);
    return [];
  }
};
